import actionTypes from './actionTypes';

const initialState = {
  shipment: {
    sid: null,
    iid: null,
    quote: {},
    summary: {},
  },
  order: {},
  isFetching: true,
  orderFailedToLoad: false,
  loaded: 0,
  notifyingCustomers: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        order: initialState.order,
        isFetching: true,
        orderFailedToLoad: false,
        loaded: 0,
      };
    case actionTypes.FETCHING:
      return {
        ...state,
        isFetching: true,
      };
    case actionTypes.FETCHED:
      return {
        ...state,
        order: action.payload.order,
        isFetching: false,
        orderFailedToLoad: false,
      };

    case actionTypes.REPLACE_SHIPMENTS:
      return {
        ...state,
        order: {
          ...state.order,
          shipments: action.payload.shipments,
        },
      };
    case actionTypes.FAILED:
      return {
        ...state,
        isFetching: false,
        orderFailedToLoad: true,
      };
    case actionTypes.UPDATE_DISTANCE:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          summary: {
            ...state.shipment.summary,
            distance: action.payload.distance,
          },
        },
      };
    case actionTypes.UPDATE_DURATION:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          summary: {
            ...state.shipment.summary,
            duration: action.payload.duration,
          },
        },
      };
    case actionTypes.UPDATE_STATUS:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          quote: {
            ...state.shipment.quote,
            status: action.payload.status,
          },
        },
      };
    case actionTypes.UPDATE_LOCATION:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          summary: {
            ...state.shipment.summary,
            location: action.payload.location,
          },
        },
      };
    // This case is just for a temp performance fix
    case actionTypes.MARK_LOADED:
      return {
        ...state,
        loaded: state.loaded + 1,
      };

    case actionTypes.START_REQUEST_BULK_ADDRESS_UPDATE:
      return {
        ...state,
        notifyingCustomers: true,
      };

    case actionTypes.FINISH_REQUEST_BULK_ADDRESS_UPDATE:
      return {
        ...state,
        notifyingCustomers: false,
      };

    default:
      return state;
  }
};
